import React from "react";
import EditForClaritySidebar from "../EditForClaritySidebar";
import type { EditForClarityReviewWorkflow } from "../hooks/useEditForClarityReviewWorkflow";

type EditForClarityToolSidebarProps = {
    workflow: EditForClarityReviewWorkflow;
};

const EditForClarityToolSidebar: React.FC<EditForClarityToolSidebarProps> = ({ workflow }) => {
    return (
        <EditForClaritySidebar
            onBack={workflow.done}
            onSubmit={(settings) => {
                void workflow.detect(settings.intensity);
            }}
            onDone={workflow.done}
            onAcceptAllRemaining={() => {
                void workflow.acceptAllRemaining();
            }}
            onPreviewClick={workflow.seekToDetection}
            onAcceptOne={(id) => {
                void workflow.acceptDetection(id);
            }}
            onRejectOne={(id) => {
                void workflow.rejectDetection(id);
            }}
            isLoading={workflow.isDetecting}
            isApplying={workflow.isApplyingAll}
            hasRun={workflow.hasRun}
            error={workflow.error}
            draft={workflow.draft}
            statusById={workflow.statusById}
            busyById={workflow.busyById}
            activeId={workflow.activeDetectionId}
        />
    );
};

export default EditForClarityToolSidebar;
